import { defineMessages } from 'react-intl';

export const giftCardsScreenCategoriesNavMessages = defineMessages({
  categoryNavItemAccessibilityLabel: {
    defaultMessage: 'Select "{category}" category',
    description: 'Gift Cards | Categories nav item accessibility label',
  },
});
